"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const account_json_1 = require("./account-json");
exports.AccountDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Account', account_json_1.AccountJsonMapper);
